import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import Button from '@ingka/button';
import { prefix } from 'app';
import Carousel from "@ingka/carousel";
import { data } from '../data'
import { useEffect, useState } from 'react';
import { PosterApi } from '@loyaltypoint/ifapi-core';
import { PosterList, PosterListElement, PosterListServiceResponse } from '@loyaltypoint/ifapi-core/dist/models';
import { useHistory } from 'react-router';
import { useIdleTimer } from 'react-idle-timer';
import Pill from "@ingka/pill";
import { arrowLeft } from '@ingka/ssr-icon/icons';

interface ProductPageProps {
  id?: string;
}

export const ProductPage = withRouter(({ match }: RouteComponentProps<ProductPageProps>) => {
  const [poster, setPoster] = useState(null as any)
  const posterApi = new PosterApi({
    basePath: process.env.REACT_APP_API_URL
  });
  let history = useHistory();

  const handleGoBack = () => {
    history.push("/");
  }

  const getWithExpiry = (key) => {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
        return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key)
        return null
    }
    return item.value
}

  useEffect(() => {
    //setItems(data)

    let key = getWithExpiry('login');
    
    if (key) {
      getPoster(key)
    }
    else {
      history.push("/login");
    }
  }, [])

  const handleOnIdle = () => {
    const time = getRemainingTime()
    if (time == 0) {
      history.push("/")
    }
  }

  const { getRemainingTime } = useIdleTimer({
    timeout: parseInt(process.env.TIMEOUT),
    onIdle: handleOnIdle,
    debounce: 500
  })


  const getPoster = async (key) => {
    let posterResponse = await posterApi.posterGetSectionProductIdGet(parseInt(match.params.id), key);
    let item = posterResponse.data.data as PosterListElement[];
    //console.log(item.prize.toString().split('.')[1])
    setPoster(item)
  }

  return (
    <div className="item-container">
      {poster &&
        <>
          <div className='text-left button-container'>
            <Pill
                label="Cofnij"
                ssrIcon={arrowLeft}
                onClick={() => handleGoBack()}
            />
          </div>
          <div className='row'>
            <div className='col-7'>
              <div className='wrapper'>
                <Carousel
                  isSlideShow={true}
                  children={poster.gallery.map((item: any) => <div><img src={item} /></div>)}
                />
              </div>
            </div>
            <div className='col-5'>
              <div className='desc-wrapper'>
                <div className='item-desc'>
                  <h1>{poster.productName}</h1>
                  <div className='item-d'>{poster.productDesc}</div>
                  <div className='item-price'> {poster.prize && poster.prize.toString().split('.')[1] ? <>{poster.prize.toString().split('.')[0]}<span className='upper-text'>,{poster.prize.toString().split('.')[1]}</span></>:<>{poster.prize},-</>}</div>
                  <div className='item-qr'>
                    <div>
                      <img src={"data:image/png;base64," + poster.qrCode}
                      />
                    </div>
                    <div className='item-qr-d'>
                      Aby dowiedzieć się więcej na temat<br /> tego produktu, zeskanuj kod QR.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      }
    </div>
  )
})